import { gql } from '@apollo/client'
import { workOrderDocumentFragment } from './graphql'
import { useActionMutation, type UseActionResult, type UseMutationProps } from '@ztechapps/common.hook'
import type { LinkNewWorkOrderTaskArgs, WorkOrder } from '@ztechapps/common.contract'

export const linkNewWorkOrderTaskQuery = gql`
  mutation linkNewWorkOrderTask($input: LinkNewWorkOrderTaskArgs!) {
    linkNewWorkOrderTask(input: $input) {
      ...workOrderDocumentFragment
    }
  }
  ${workOrderDocumentFragment}
`

export const useLinkNewProjectTask = (
  { query, ...props } = {} as UseMutationProps
): UseActionResult<WorkOrder, LinkNewWorkOrderTaskArgs> => {
  query = query ?? linkNewWorkOrderTaskQuery

  return useActionMutation({
    query,
    ...props,
  })
}
